<template>
  <v-row class="mb-15 fill-height">
    <v-col>
      <v-row>
        <v-col>
          <h1>Reporte de Emision Asistencias</h1>
        </v-col>
      </v-row>
      <v-row style="padding-left: 30px; margin-top: 25px"> </v-row>
      <v-row class="mb-15" style="padding-left: 30px">
        <v-col md="3">
          <h3>Selecciona el rango de fechas</h3>
          <v-date-picker
            style="width: 100%"
            v-model="dates"
            range
          ></v-date-picker>
          <v-btn
            rounded
            color="primary"
            style="width: 100%"
            dark
            @click="consultar(false)"
            >Consultar</v-btn
          >
          <v-btn
            rounded
            color="primary"
            style="width:100%;margin-top:20px;"
            :disabled="bloquear"
            @click="consultar(true)"
          >
            Descargar Información
          </v-btn>
          <!-- <v-btn
            rounded
            color="primary"
            style="width:100%;margin-top:20px;"
            :disabled="bloquear"
            v-show="
              currentRol == 'ADMIN' ||
                currentRol == 'ADMINCC' ||
                currentRol == 'AUDITOR' ||
                currentRol == 'MANAGERCC'
            "
          >
            <download-csv
              :data="reportDownloadIt"
              name="Informe_seguro_asistencias_bradescard.csv"
            >
              Descargar Informe TI
            </download-csv>
          </v-btn> -->
        </v-col>
        <v-col cols="9" md="9">
          <div>
            <div v-if="loading" style="text-align: center">
              <h2 clas="pb-4">Cargando Reporte....</h2>
              <br /><br />
              <md-progress-spinner
                :md-diameter="100"
                :md-stroke="10"
                md-mode="indeterminate"
              />
            </div>
          </div>

          <v-data-table
            :headers="columns"
            :items="leads"
            item-key="name"
            class="elevation-1"
            :search="search"
            :custom-filter="filterOnlyCapsText"
            :server-items-length="totalRegistros"
            :loading="loading"
            loading-text="Cargando..."
            :items-per-page="elementosPagina"
            @update:page="pagina = $event"
            @update:items-per-page="elementosPagina = $event"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Buscar"
                class="mx-4"
              ></v-text-field>
            </template>

            <!-- <template v-slot:item.urlPoliza="{ item }">
                                <v-btn :href="'https://segurify-data.s3.amazonaws.com/' + item.urlPoliza">Descargar</v-btn>
                            </template> -->
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
var moment = require("moment-timezone");
import download from "downloadjs";
import { ListExpanded } from "../../../../plugins/mixins";

export default {
  mixins: [ListExpanded],

  data() {
    return {
      dates: ["", ""],
      roles: JSON.parse(localStorage.getItem("roles")),
      agenteUuid: localStorage.getItem("agenteUuid"),
      loading: false,
      reportType: "lead",
      leads: [],
      search: "",
      reportDownloadIt: [],
      reportCompleteDowload: [],
      bloquear: true,
      block: true,
      canal: null,
      canales: [
        { id: 1, name: "AGENTES" },
        { id: 2, name: "MASIVOS" },
        { id: 3, name: "DIRECTOS" },
      ],

      columns: [
        { text: "Poliza", value: "polizaInterna" },
        { text: "Cliente", value: "cliente" },
        { text: "Fecha inicio vigencia", value: "fecha_inicio_vigencia" },
        { text: "Fecha fin vigencia", value: "fecha_fin_vigencia" },
        { text: "Producto", value: "producto" },
        { text: "Plan", value: "plan" },
        { text: "Prima neta", value: "prima_neta" },
        { text: "Ejecutivo CC", value: "ejecutivo" },
      ],
      pagina: 1,
      elementosPagina: 10,
      totalRegistros: 0,
    };
  },

  watch: {
    pagina(v) {
      !!v && this.consultar();
    },

    elementosPagina(v) {
      !!v && this.consultar();
    },
  },

  methods: {
    convertDate(date) {
      const dateRes = moment(date);
      dateRes.tz("UTC", true);
      return dateRes.tz("America/Mexico_City").format("DD-MM-YYYY HH:mm");
    },

    async consultar(file = false) {
      this.loading = true;

      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      var inicioUTC = null;
      var finUTC = null;

      if (this.dates.length > 0) {
        if (this.dates[1]) {
          inicioUTC = moment
            .utc(this.dates[0])
            .format("YYYY-MM-DD");
          finUTC = moment
            .utc(this.dates[1])
            .format("YYYY-MM-DD");
        } else {
          inicioUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD");
          finUTC = moment
            .utc(this.dates[0])
            .format("YYYY-MM-DD");
        }
      }
      let query = {
        fechas: [inicioUTC, finUTC],
        elementosPagina: this.elementosPagina,
        pagina: this.pagina,
      };

      // this.$axios.post("v1/bradescard/emisiones/productoAseg", query, config).then((response) => {
      //   response.data.map(element => {
      //     this.leads.push({
      //             uuid: element.uuid,
      //             polizaInterna: element.polizaInterna ? element.polizaInterna : 'No disponible',
      //             cliente: (element.nombre ? element.nombre : ' ') + ' ' + (element.apellido_paterno ? element.apellido_paterno : ' ') + ' ' + (element.apellido_materno ? element.apellido_materno : ' '),
      //             fecha_inicio_vigencia: element.inicio ? moment.utc(element.inicio).subtract(6, 'hours').format('DD/MM/YYYY HH:mm:ss') : 'No Disponible',
      //             fecha_fin_vigencia: element.fin ? moment.utc(element.fin).subtract(6, 'hours').format('DD/MM/YYYY HH:mm:ss') : 'No Disponible',
      //             tipo_contratante: element.tipo_contratanteE ? element.tipo_contratanteE : 'No disponible',
      //             producto: element.producto ? element.producto : 'No disponible',
      //             plan: element.etiqueta_aseguradora ? element.etiqueta_aseguradora : 'No disponible',
      //             prima_neta: element.prima_neta ? this.toCurrency(element.prima_neta) : 'No disponible',
      //             ejecutivo: element.ejecutivo ? element.ejecutivo : 'No disponible'

      //         })
      //   })
      //     this.bloquear = false
      // });

      let route = `/v1/bradescard/emisiones/asistencias`;
      if (file) route += "/file";
      let { data } = await this.$axios.post(route, query, config);

      if (file) return this.manageFileResponse(data);

      this.reportDownloadIt = [];
      this.leads = [];

      if (data.length) this.totalRegistros = data[0].totalRegistros;

      data.map((element) => {
        this.leads.push({
          uuid: element.uuid,
          polizaInterna: element.polizaInterna
            ? element.polizaInterna
            : "No disponible",
          cliente:
            (element.nombre ? element.nombre : " ") +
            " " +
            (element.apellido_paterno ? element.apellido_paterno : " ") +
            " " +
            (element.apellido_materno ? element.apellido_materno : " "),
          fecha_inicio_vigencia: element.inicio
            ? moment.utc(element.inicio).format("DD/MM/YYYY HH:mm:ss")
            : "No Disponible",
          fecha_fin_vigencia: element.fin
            ? moment.utc(element.fin).format("DD/MM/YYYY HH:mm:ss")
            : "No Disponible",
          tipo_contratante: element.tipo_contratanteE
            ? element.tipo_contratanteE
            : "No disponible",
          producto: element.producto ? element.producto : "No disponible",
          plan: element.etiqueta_aseguradora
            ? element.etiqueta_aseguradora
            : "No disponible",
          prima_neta: element.prima_neta
            ? this.toCurrency(element.prima_neta)
            : "No disponible",
          ejecutivo: element.ejecutivo ? element.ejecutivo : "No disponible",
        });
        this.bloquear = false;
      });

      this.loading = false;
    },

    manageFileResponse(responseData) {
      download(
        responseData,
        `Informe_seguro_asistencias_bradescard.csv`,
        "application/csv"
      );

      this.loading = false;
    },

    toCurrency(number) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return formatter.format(number); /* $2,500.00 */
    },
    // Table
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },
  },
  computed: {
    blockBoton() {
      return this.canal != null && this.dates != ["", ""];
    },
    canShow() {
      var canView = false;
      var roles = [];
      this.roles.forEach((element) => {
        roles.push(element.rol);
      });
      const rolesToView = ["ADMIN", "DIRECTOR", "FINANZAS"];
      roles.forEach((element) => {
        if (rolesToView.includes(element)) {
          canView = true;
        }
      });
      return canView;
    },
    currentRol() {
      let roles = [];
      this.roles.forEach((element) => {
        if (element.rol != null) {
          roles.push(element.rol);
        }
      });

      if (roles.length > 0) {
        return roles[0];
      } else {
        return "";
      }
    },
  },
};
</script>
